import { render, staticRenderFns } from "./BannerItem.vue?vue&type=template&id=53c71644&"
import script from "./BannerItem.vue?vue&type=script&lang=js&"
export * from "./BannerItem.vue?vue&type=script&lang=js&"
import style0 from "./BannerItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports